/* KOTH cart offer: AJAX add for roll-on, AJAX signup + code reveal, re-render on cart change. */
(function () {
  const sel = '[data-koth-offer]';
  async function refresh() {
    // Re-render the cart drawer section so the offer flips between states (1 vs 2+ colognes).
    document.dispatchEvent(new CustomEvent('koth:cart-refresh'));
    try {
      const r = await fetch(window.location.pathname + (window.location.search ? window.location.search + '&' : '?') + 'section_id=cart-drawer');
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = doc.querySelector(sel);
      document.querySelectorAll(sel).forEach(el => fresh && el.replaceWith(fresh.cloneNode(true)));
    } catch (e) {}
  }
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-koth-add]');
    if (!b) return;
    b.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    const onCartPage = !!document.querySelector('cart-items, main-cart-items') && /\/cart\/?$/.test(window.location.pathname);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.kothAdd), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }) });
      const json = await res.json();
      if (onCartPage) { window.location.reload(); return; }
      if (drawer && typeof drawer.renderContents === 'function' && json.sections) { drawer.renderContents(json); return; }
    } catch (err) {}
    refresh();
  });
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-koth-signup]');
    if (!f) return;
    e.preventDefault();
    const res = await fetch(f.action, { method: 'POST', body: new FormData(f) });
    // Shopify returns 200 on success; a challenge page may appear -> fall back to native submit.
    if (res.ok && !res.url.includes('challenge')) {
      f.hidden = true;
      const c = f.parentElement.querySelector('[data-koth-code]'); if (c) c.hidden = false;
      try { localStorage.setItem('koth_welcome10', '1'); } catch (_) {}
    } else { f.submit(); }
  });
  // Dawn-based theme: cart changes are published via pubsub (PUB_SUB_EVENTS.cartUpdate), not a DOM event.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refresh, 300));
  document.addEventListener('cart:updated', refresh);
})();
